module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"form-group\"> <label class=\"dropdown-label\">Key</label> <div class=\"contained-input d-flex justify-content-between\"> ")
    ; __append(escapeFn( locals.api_key ))
    ; __append(" <div> <button class=\"copy-key-btn clean-icon-btn text-secondary\" type=\"button\" data-clipboard-text=\"")
    ; __append(escapeFn( locals.clipboard_text ))
    ; __append("\"> <span class=\"fa fa-copy\"></span> </button> ")
    ;  if(locals.mode === 'production') { 
    ; __append(" <button class=\"show-key-btn clean-icon-btn text-secondary\" type=\"button\" title=\"Hide/Show key\"> <span class=\"fa ")
    ; __append(escapeFn( locals.show_production ? 'fa-eye-slash' : 'fa-eye' ))
    ; __append("\"></span> </button> ")
    ;  } 
    ; __append(" </div> </div> </div> <div class=\"form-group\"> <label class=\"dropdown-label\">Status</label> <div> <label class=\"switch\"> <input class=\"active-status-checkbox\" type=\"checkbox\" ")
    ; __append(escapeFn( locals.active ? 'checked' : '' ))
    ; __append("> <div class=\"slider round\"></div> </label> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/api_keys/list_item.ejs
// module id = 1209
// module chunks = 1